import React, { useMemo } from 'react';
import './EICheckBox.scss';
import { EICheckBoxProps, EISelectBoxProps } from 'business/models/CustomModels';
import { ReactComponent as CloseIcon } from 'Icons/Sidebar/HighPhClose.svg';
import { IStyle } from 'Styles';

const renderOptions = (options) =>
  options.map((val, index) => (
    <option
      key={val.value}
      data-testid={`layers-options-${val.value}-${index}`}
      value={val.value}
    >
      {val.name}
    </option>
  ));

const labelFixedStyle = {
  marginLeft: '0px',
};
const checkBoxStyle1 = {
  width: '100%',
  fontSize: '1.0rem',
  paddingTop: '6px',
};

export function EIClickBox({
  textBoxText,
  active = false,
  onClick,
  isShowClose = false,
}: EICheckBoxProps) {
  return (
    <div
      data-testid="layers-eicheckbox-eiclickbox-wrapper"
      className="flex flex-space-between w-100pr ei-container"
    >
      <div
        data-testid={`layers-eicheckbox-eiclickbox-content-${textBoxText}`}
        className={`ei-text-box cursor-pointer ${active ? 'active-ei-text-box' : ''} ${
          isShowClose ? 'active-close-btn' : ''
        }`}
        style={checkBoxStyle1}
        onClick={onClick}
      >
        {textBoxText}
      </div>
    </div>
  );
}

export default function EICheckBox({
  labelText,
  textBoxText,
  active = false,
  onClick,
  isShowClose = false,
  onClose,
}: EICheckBoxProps) {
  return (
    <div
      data-testid="layers-eicheckbox-content-wrapper"
      className="flex flex-space-between w-100pr ei-container"
    >
      <label
        data-testid={`layers-eicheckbox-content-label-${labelText}`}
        className="ei-label gridlayer-label"
      >
        {labelText}
      </label>
      <div
        data-testid={`layers-eicheckbox-content-${textBoxText}`}
        className={`ei-text-box cursor-pointer ${active ? 'active-ei-text-box' : ''} ${
          isShowClose ? 'active-close-btn' : ''
        }`}
        style={{ width: isShowClose ? '94%' : '100%' }}
        onClick={onClick}
      >
        {textBoxText}
      </div>
      {isShowClose && (
        <CloseIcon
          data-testid="layers-eicheckbox-close-icon"
          style={{ marginLeft: '2%', cursor: 'pointer' }}
          onClick={onClose}
        />
      )}
    </div>
  );
}

export function EICheckBoxVertical({
  labelText,
  textBoxText,
  active = false,
  onClick,
  isShowClose = false,
  onClose,
}: EICheckBoxProps) {
  return (
    <div
      data-testid="layers-eicheckbox-eicheckboxvertical-wrapper"
      className="flex flex-column flex-space-between w-100pr ei-container"
    >
      <label
        data-testid={`layers-eicheckbox-eicheckboxvertical-content-label-${labelText}`}
        className="ei-label gridlayer-label w-100 pb-2"
      >
        {labelText}
      </label>
      <div
        data-testid={`layers-eicheckbox-eicheckboxvertical-content-${textBoxText}`}
        className={`ei-text-box cursor-pointer ${active ? 'active-ei-text-box' : ''} ${
          isShowClose ? 'active-close-btn' : ''
        }`}
        style={{ width: isShowClose ? '94%' : '100%' }}
        onClick={onClick}
      >
        {textBoxText}
      </div>
      {isShowClose && (
        <CloseIcon
          data-testid="layers-eicheckbox-eicheckboxvertical-close-icon"
          style={{ marginLeft: '2%', cursor: 'pointer' }}
          onClick={onClose}
        />
      )}
    </div>
  );
}

export function EISelectBox(props: EISelectBoxProps) {
  const {
    labelText,
    selectedValue,
    onChange,
    options,
    disabled = false,
    selectStyle,
    labelStyle,
    containerStyle,
    selectClassName,
    labelClassName,
    containerClassName,
  } = props;
  return (
    <div
      data-testid="layers-eicheckbox-eiselectbox-wrapper"
      style={containerStyle}
      className={`flex flex-space-between w-100pr ${containerClassName} ${
        !containerStyle && 'ei-container'
      }`}
    >
      {labelText && (
        <label
          data-testid={`layers-eicheckbox-eiselectbox-label-${labelText}`}
          className={`ei-label gridlayer-label ${labelClassName}`}
          style={{ labelFixedStyle, ...labelStyle }}
        >
          {labelText}
        </label>
      )}
      <select
        data-testid="layers-eicheckbox-eiselectbox-select"
        style={{ ...styles.selectFixedStyle, ...selectStyle }}
        value={selectedValue}
        onChange={onChange}
        disabled={disabled}
        className={`${selectClassName}`}
      >
        {renderOptions(options)}
      </select>
    </div>
  );
}

export function EISelectBoxVertical(props: EISelectBoxProps) {
  const {
    labelText,
    selectedValue,
    onChange,
    options,
    disabled = false,
    selectStyle,
    labelStyle,
    containerStyle,
  } = props;
  return (
    <div
      data-testid="layers-eicheckbox-eiselectbox-vertical-wrapper"
      style={containerStyle}
      className={`flex flex-column flex-space-between w-100pr ${
        !containerStyle && 'ei-container'
      }`}
    >
      {labelText && (
        <label
          data-testid={`layers-eicheckbox-eiselectbox-vertical-label-${labelText}`}
          className="ei-label gridlayer-label w-100 pb-2"
          style={{ labelFixedStyle, ...labelStyle }}
        >
          {labelText}
        </label>
      )}
      <select
        data-testid="layers-eicheckbox-eiselectbox-vertical-select"
        style={{ ...styles.selectFixedStyle, ...selectStyle }}
        value={selectedValue}
        onChange={onChange}
        disabled={disabled}
      >
        {renderOptions(options)}
      </select>
    </div>
  );
}

export function ScoringToolNameSelectBox({
  labelText,
  placeholder,
  selectedValue,
  onChange,
  options,
  disabled = false,
  selectStyle,
  containerStyle,
}: EISelectBoxProps) {
  const selectBoxOptions = useMemo(() => {
    return options.map((val) => {
      return (
        <option
          key={val.value}
          value={val.name}
          data-testid={`layers-eicheckbox-scoringtoolnameselectbox-option-${val.name}`}
        >
          {val.name}
        </option>
      );
    });
  }, [options]);

  return (
    <div
      data-testid="layers-eicheckbox-scoringtoolnameselectbox-wrapper"
      style={containerStyle}
      className="flex flex-space-evenly flex-y-center w-100pr ei-container"
    >
      <select
        data-testid="layers-eicheckbox-scoringtoolnameselectbox-select"
        style={{ ...styles.selectBox, ...selectStyle }}
        value={selectedValue}
        onChange={onChange}
        disabled={disabled}
      >
        {selectBoxOptions}
      </select>
    </div>
  );
}

export function ScoringToolValueSelectBox({
  labelText,
  placeholder,
  selectedValue,
  onChange,
  options,
  disabled = false,
  selectStyle,
  containerStyle,
}: EISelectBoxProps) {
  const selectBoxOptions = useMemo(() => {
    return options.map((val) => {
      return (
        <option
          data-testid={`layers-eicheckbox-scoringtoolvalueselectbox-option-${val.name}`}
          key={val.value}
          value={val.value}
        >
          {val.name}
        </option>
      );
    });
  }, [options]);

  return (
    <div
      data-testid="layers-eicheckbox-scoringtoolvalueselectbox-wrapper"
      style={containerStyle}
      className="flex flex-space-evenly flex-y-center w-100pr ei-container"
    >
      <select
        data-testid="layers-eicheckbox-scoringtoolvalueselectbox-select"
        style={{ ...styles.selectBox, ...selectStyle }}
        value={selectedValue}
        onChange={onChange}
        disabled={disabled}
      >
        {selectBoxOptions}
      </select>
    </div>
  );
}

export function UnitTextBox({
  labelText,
  unit,
  inputValue,
  onChange,
  error = false,
  isDisabled = false,
  labelStyle = undefined,
  labelClassName = '',
  containerClassName = '',
  unitClassName = '',
  inputDivClassName = '',
}) {
  return (
    <div
      data-testid="layers-eicheckbox-unittextbox-wrapper"
      className={`flex flex-space-between flex-y-center unit-box-container ${containerClassName}`}
    >
      <label
        data-testid={`layers-eicheckbox-unittextbox-label-${labelText}`}
        style={labelStyle}
        className={`ei-label gridlayer-label ${labelClassName}`}
      >
        {labelText}
      </label>
      <div
        data-testid="layers-eicheckbox-unittextbox-input-wrapper"
        style={{ ...styles.unitDiv }}
        className={`${inputDivClassName}`}
      >
        <input
          data-testid={`layers-eicheckbox-unittextbox-input-wrapper-${labelText}`}
          className={`unit-box-input ${error ? 'input-error' : ''} ${
            isDisabled ? 'disable-element' : ''
          }`}
          type="text"
          onChange={onChange}
          value={inputValue}
        />
      </div>

      <div
        data-testid={`layers-eicheckbox-unittextbox-unit-${labelText}`}
        className={`ei-label gridlayer-label ${unitClassName}`}
        style={{ ...styles.unit }}
      >
        {unit}
      </div>
    </div>
  );
}

const styles: IStyle = {
  selectBox: {
    width: '82.44%',
    height: '2.125rem',
    boxSizing: 'border-box',
    padding: '4.25px 9px',
  },
  selectFixedStyle: {
    width: '100%',
    height: '2.125rem',
    boxSizing: 'border-box',
    padding: '4.25px 9px',
  },
  unitDiv: {
    paddingLeft: '26%',
  },
  unit: {
    paddingLeft: '2%',
  },
};
